import { Platform } from "react-native";
import { store } from "@store";
import { setAppConfigsApi } from "@services/api";
import DeviceInfo from "react-native-device-info";
import messaging from "@react-native-firebase/messaging";
import {
  checkNotifications,
  requestNotifications,
} from "react-native-permissions";

const setAppConfigs = async (id) => {
  const { auth } = store.getState();
  if (auth?.user?.user_id) {
    let status = null;
    try {
      try {
        const { status: notificationstatus } = await checkNotifications();
        status = notificationstatus;
      } catch (e) {
        console.log(e);
      }
      if (status !== "blocked" && status !== "granted" && Platform.Version >= 33) {
        await requestNotifications(["alert", "sound"]);
      }
      const fcm_token = await messaging().getToken();
      await setAppConfigsApi(
        DeviceInfo.getVersion(),
        DeviceInfo.getBuildNumber(),
        fcm_token,
        status,
      );
    } catch (e) {
      console.log(e);
    }
  }
};

export default setAppConfigs;
